<div class="container-fluid m-0 p-0" appFitViewport [ngClass]="{ 'dark-theme': isDark, 'light-theme': !isDark }" style="overflow: hidden;">
    <!-- Panel flotante de control -->
    <div class="floating-control-panel" (mouseenter)="expandirDiv()" (mouseleave)="contraerDiv()" 
         [ngClass]="{'expanded': mouseSobreDiv}">
        <div class="panel-toggle">
            <mat-icon>{{mouseSobreDiv ? 'chevron_left' : 'menu'}}</mat-icon>
        </div>
        <div class="panel-content">
            <h6 class="panel-title mb-2">Paneles</h6>
            <div class="panel-option">
                <mat-checkbox [checked]="cartera" (change)="showTab('cartera')" [color]="'primary'">
                    Cartera
                </mat-checkbox>
            </div>
            <div class="panel-option">
                <mat-checkbox [checked]="listaMercado" (change)="showTab('lista')" [color]="'primary'">
                    Lista Mercados
                </mat-checkbox>
            </div>
        </div>
    </div>

    <div class="row-container p-0 m-0" #rowContainer style="height: 100%;">
        <div class="mb-4 col-md-2 p-0 m-0 resizable-column h-100" #column1 *ngIf="cartera" data-key="gestor_col_cartera">
            <div class="resizer" (mousedown)="startResizing($event, column1)" title="Arrastrar para redimensionar"></div>
            <mat-card class=" enrolled-created-box ccorbit-card no-scrollbar h-100">
                <mat-card-content class="h-100 d-flex flex-column">
                    <div class="ccorbit-form-group without-icon">
                        <h5 class="etiquetas" style="display: flex; justify-content: space-between; align-items: center;">
                            CARTERA ÓPTIMA
                            <mat-icon style="cursor: pointer; font-size: 18px;" (click)="showCarteraHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                        </h5>

                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Capital Inicial</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.capitalinicial"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Valor Liquidativo Neto</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.valorLiquidativo"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Efectivo</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.efectivo"
                                    [disabled]="true" [ngClass]="{'input-error-letra': !efectivopositivo}">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Tipo Cuenta</label>
                            </div>
                            <div class="col-5 d-flex">
                                <select class="form-select form-select-sm select listas compact-select"
                                    aria-label=".form-select-sm example" (change)="disabledMargin($event)"
                                    [(ngModel)]="optimalWallet.tipocuenta" [disabled]="true">
                                    <option selected>Seleccionar</option>
                                    <option value="{{type}}" *ngFor=" let type of accountType">{{type}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Margen Requerido %</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.margenRequeridoPor"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Control Margin Call %</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.controlMarginCall"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Margen Total</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.margen"
                                    [disabled]="true" [ngClass]="{'input-error': !existemargen}">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Fondos Disponibles</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.fondosDisponibles"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Poder Aquisitivo</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.poderCompra"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Apalancamiento</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.apalancamiento"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <h5 class="etiquetas" style="display: flex; justify-content: space-between; align-items: center;">
                                CONFIGURACIÓN RIESGO
                                <mat-icon style="cursor: pointer; font-size: 18px;" (click)="showRiesgoHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                            </h5>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Riesgo Maximo</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.riesgomaximo"
                                    [disabled]="true" [ngClass]="{'input-error': !existeriesgo}">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Tipo Riesgo</label>
                            </div>
                            <div class="col-5 d-flex">
                                <select class="form-select form-select-sm select listas compact-select"
                                    aria-label=".form-select-sm example" [(ngModel)]="optimalWallet.tiporiesgo"
                                    [disabled]="true">
                                    <option value="{{type}}" *ngFor="let type of purchaseTypes">{{type}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Valor Riesgo</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.riesgo"
                                    [disabled]="true">
                            </div>
                        </div>

                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Comisión 2/2</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.comisionbroker"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <label class="fw-semibold gray-color small-label">Stop Loss</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.stopLoss"
                                    [disabled]="true" min="0.001" max="100">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <mat-checkbox class="compact-checkbox me-1" [checked]="optimalWallet.chkgastogest"
                                    [(ngModel)]="optimalWallet.chkgastogest" [color]="'primary'" [disabled]="true"></mat-checkbox>
                                <label class="fw-semibold gray-color small-label">Gastos Gestión</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.gastosGestionPor"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-7 d-flex align-items-center">
                                <mat-checkbox class="compact-checkbox me-1" [checked]="optimalWallet.chkgastoprest"
                                    [(ngModel)]="optimalWallet.chkgastoprest" [color]="'primary'" [disabled]="true"></mat-checkbox>
                                <label class="fw-semibold gray-color small-label">Gastos Prestamo %</label>
                            </div>
                            <div class="col-5 d-flex">
                                <input type="number" class="text-center compact-input" [(ngModel)]="optimalWallet.gastosPrestamoPor"
                                    [disabled]="true">
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-12 d-flex align-items-center">
                                <mat-checkbox class="compact-checkbox me-1" [checked]="optimalWallet.participacion"
                                    [(ngModel)]="optimalWallet.participacion" [color]="'primary'" [disabled]="true"></mat-checkbox>
                                <label class="fw-semibold gray-color small-label">Comprar/Vender Fracciones</label>
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col-12 d-flex">
                                <button mat-flat-button class="ccorbit d-block fw-semibold w-100" (click)="openDialog()">
                                    <mat-icon class="me-1">settings</mat-icon>
                                    Reconfigurar
                                </button>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="mb-4 col-md-3 p-0 m-0 resizable-column h-100" *ngIf="listaMercado" #column2 data-key="gestor_col_lista">
            <div class="resizer" (mousedown)="startResizing($event, column2)" title="Arrastrar para redimensionar"></div>
            <mat-card class=" enrolled-created-box ccorbit-card no-scrollbar h-100">
                <mat-card-content class="h-100 d-flex flex-column">
                    <h5 class="etiquetas">SELECCIONAR MERCADO</h5>
                    <div class="flex-fill overflow-auto">
                      <app-tablamercado [idcartera]="idcartera"></app-tablamercado>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>


        <div class="col p-0 m-0 h-100">
            <mat-card class="enrolled-created-box ccorbit-card no-scrollbar h-100">
                <div class="row  mt-2">

                    <div class="col-8 d-flex ">
                        <div class="cartera-title  alert alert-danger">
                            <span>GESTOR DE CARTERAS: {{optimalWallet.nombre}}</span>
                        </div>
                    </div>

                    <div class="col-4 mt-1" *ngIf="this.suscrito">
                        <button class="botones" style="background-color: brown;" (click)="confirmar(true)"
                            *ngIf="!_cookieService.check('auto'+optimalWallet.idcartera) && suscrito">Automatizar</button>
                        <button class="botones" style="background-color: rgb(58, 112, 17);" (click)="confirmar(true)"
                            *ngIf="_cookieService.check('auto'+optimalWallet.idcartera) && suscrito">Confirmado</button>
                        <button class="botones" (click)="reset()">Reset</button>
                    </div>

                </div>

                <mat-card-content class="h-100 d-flex flex-column">
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                        (selectedTabChange)="onTabChange($event)" class="flex-fill">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Gestión/Contabilidad
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('gestion', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-planificador-gestion [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading">
                            </app-planificador-gestion>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Operaciones
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('operaciones', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-operations [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading"></app-operations>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Valores liquidativos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('valores', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-liquidating-values [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading"></app-liquidating-values>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Rendimientos/Riesgos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('rendimientos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-rendimientoriesgo [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading"></app-rendimientoriesgo>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Posiciones Cartera
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('cartera', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-cartera [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading"></app-cartera>
                        </mat-tab>

                    </mat-tab-group>
                </mat-card-content>
            </mat-card>
        </div>

    </div>
</div>